export default "__VITE_ASSET__BPNtN4zc__"